import { socialMediaOptions } from './SocialMediaSection';
import { useSelector } from 'react-redux';
import type { RootState } from '@/app/store';
import { XIcon } from 'lucide-react';
import { useAppDispatch } from '@/app/hooks';
import { deleteSocialMediaLink } from '@/features/workspace/workspaceThunks';
import { useWebinarT } from '@/hooks/useWebinarT';

export default function MySocialsMedia() {
  const dispatch = useAppDispatch();
  const socials = useSelector((s: RootState) => s.workspace.currentWorkspace?.socials ?? []);
  const workspaceId = useSelector((s: RootState) => s.workspace.currentWorkspace?.id);
  const { t } = useWebinarT('webinars');

  const handleDelete = (id: number) => {
    if (!workspaceId) return;
    dispatch(deleteSocialMediaLink({ workspaceId, id }));
  };

  return (
    <div className="space-y-4">
      {socials.map((s) => {
        const socialOption = socialMediaOptions.find((option) => option.value === s.socialMedia);

        return (
          <div key={s.id} className="flex items-center gap-2">
            <div className="w-1/3  relative px-4 py-1 h-12 rounded-lg border border-input">
              <label className="absolute transition-all duration-200 pointer-events-none text-tertiary text-sm top-0 left-3 px-1">
                {t('socialMedia.form.networkLabel')}
              </label>
              <div className="w-full text-base focus:outline-none focus:ring-0 focus:border-transparent pt-4 flex items-center gap-2">
                {socialOption?.icon}
                <span className="font-medium">{socialOption?.label || s.socialMedia}</span>
              </div>
            </div>

            <div className="w-2/3 relative px-4 py-1 h-12 rounded-lg border border-input">
              <label className="absolute transition-all duration-200 pointer-events-none text-tertiary text-sm top-0 left-3 px-1">
                {t('socialMedia.form.urlLabel')}
              </label>
              <div className="w-full text-base focus:outline-none focus:ring-0 focus:border-transparent pt-4 truncate">
                {s.url}
              </div>
            </div>

            <div className=" shrink-0">
              <XIcon
                className="size-6 cursor-pointer text-error "
                onClick={() => handleDelete(s.id)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
